import React from "react";
import Test from "./Test";
import { useNavigate } from "react-router-dom";

import styles from "./room.module.css";
const MainRoom = () => {
  const navigate = useNavigate();
  return (
    <div>
      <header id={styles.nav}>
        <div className={styles.navlist}>
          <button id={styles.members__button}></button>
          <div
            onClick={() => {
              navigate("/final");
            }}
          >
            <h3 id={styles.logo}>
              <span>We Together</span>
            </h3>
          </div>
        </div>
        <div id={styles.nav__links}>
          <button id={styles.chat__button}>
            {/* <svg
              width={24}
              height={24}
              xmlns="http://www.w3.org/2000/svg"
              fillRule="evenodd"
              fill="#ede0e0"
              clipRule="evenodd"
            >
              <path d="M24 20h-3v4l-5.333-4h-7.667v-4h2v2h6.333l2.667 2v-2h3v-8.001h-2v-2h4v12.001zm-15.667-6l-5.333 4v-4h-3v-14.001l18 .001v14h-9.667zm-6.333-2h3v2l2.667-2h8.333v-10l-14-.001v10.001z" />
            </svg> */}
          </button>
          {/* <a class="nav__link" href="/">
                Lobby
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#ede0e0" viewBox="0 0 24 24"><path d="M20 7.093v-5.093h-3v2.093l3 3zm4 5.907l-12-12-12 12h3v10h7v-5h4v5h7v-10h3zm-5 8h-3v-5h-8v5h-3v-10.26l7-6.912 7 6.99v10.182z"/></svg>
            </a> */}
          <div
            onClick={() => {
              navigate("/final");
            }}
            className={styles.nav__link}
            id={styles.create__room__btn}
          >
            Create Room
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              fill="#ede0e0"
              viewBox="0 0 24 24"
            >
              <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 13h-5v5h-2v-5h-5v-2h5v-5h2v5h5v2z" />
            </svg>
          </div>
        </div>
      </header>
      <main className={styles.container}>
        <div id={styles.room__container}>
          <section id={styles.members__container}>
            <div id={styles.members__header}>
              <p>Participants</p>
              <strong id={styles.members__count}>0</strong>
            </div>
            <div id={styles.member__list}></div>
          </section>
          <section id={styles.stream__container}>
            <div id={styles.stream__controles}>
              <Test />
              {/* <button id="join-btn" className={styles.join_btn}>
                Join Stream
              </button> */}
            </div>
          </section>
          <section id={styles.messages__container}>
            <div id={styles.messages} />
            <form id={styles.message__form}>
              <input
                type="text"
                name="message"
                placeholder="Send a message...."
              />
            </form>
          </section>
        </div>
      </main>
    </div>
  );
};

export default MainRoom;
